<template>
  <div
    v-if="isCustomAction"
    class="flex items-center w-full gap-8 min-h-[24px] c-sharing-settings-preset-selector__custom-action"
  >
    <FontAwesomeIcon
      :icon="['fak', 'wrench']"
      :style="{ height: '16px', width: '16px', color: 'currentColor' }"
      class="c-sharing-settings-preset-selector__custom-icon"
      :class="isSelected ? 'text-secondary-accent' : 'text-neutral-text-weak'"
    />
    <span class="flex-1">{{ option.label }}</span>
    <BittsButton
      v-if="showActionButton"
      aria-label="View sharing details"
      variant="ghost"
      type="neutral"
      size="small"
      :center-icon="actionIcon"
      @click="handleActionClick"
    />
  </div>
  <div v-else class="flex items-center w-full gap-8 min-h-[24px]">
    <span class="flex-1 truncate">{{ option.label }}</span>
    <BittsTag
      v-if="isRecommended"
      color="info"
      size="x-small"
      text="Recommended"
    />
    <BittsButton
      v-if="!isRecommended && actionIcon"
      aria-label="View sharing details"
      variant="ghost"
      type="neutral"
      size="small"
      :center-icon="actionIcon"
      @click="handleActionClick"
    />
  </div>
</template>

<script setup lang="ts">
import { BittsButton, BittsTag } from '@crossbeam/bitts';
import { BittsIconPrefix } from '@crossbeam/bitts/src/types';

import { computed } from 'vue';

import type { PresetOptionItem } from '@/types/data_share_presets';

const props = defineProps<{
  option: PresetOptionItem;
  actionIcon: [BittsIconPrefix, string] | null;
  isSelected?: boolean;
}>();

const emit = defineEmits<{
  'action-click': [event: Event];
}>();

const isCustomAction = computed(() => {
  return (
    props.option.value === 'custom' ||
    props.option.presetType === 'single_share_preset'
  );
});

const isRecommended = computed(() => {
  return props.option.presetType === 'crossbeam_default';
});

const showActionButton = computed(() => {
  return props.option.presetType === 'single_share_preset' && props.actionIcon;
});

function handleActionClick(event: Event) {
  emit('action-click', event);
}
</script>
